if (!customElements.get('video-facade')) {
  class VideoFacade extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.video-facade__play');
      this.button?.addEventListener('click', this.handleActivate);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleActivate);
    }

    handleActivate() {
      const url = this.dataset.videoUrl;
      if (!url) return;

      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.title = this.dataset.videoTitle || this.button?.getAttribute('aria-label') || '';
      iframe.className = `video-facade__iframe ${this.dataset.iframeClass || ''}`.trim();
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';

      this.replaceChildren(iframe);
      iframe.tabIndex = -1;
      iframe.focus();
    }
  }

  customElements.define('video-facade', VideoFacade);
}
